const PLAYBACK_BASE = 'https://www.thelessonspace.com/playback';

// Build a Lessonspace playback URL for a session.
// Prefers an explicit recording link when the sync stored one; otherwise falls
// back to the Lessonspace session UUID, which is populated far more often.
export const buildLessonspaceRecordingUrl = ({
  recordingLink,
  lessonspaceSessionId,
  sessionExternalId,
  timestampSeconds,
} = {}) => {
  const withTs = (url) => {
    if (!timestampSeconds || /[?&]ts=/.test(url)) return url;
    return `${url}${url.includes('?') ? '&' : '?'}ts=${Math.max(0, Math.floor(timestampSeconds))}`;
  };

  if (recordingLink) {
    // The sync stores Lessonspace's API playback endpoint
    // (api.thelessonspace.com/v2/organisations/<org>/sessions/<uuid>/playback/),
    // which needs our API key and errors in a browser. Send viewers to the
    // web playback page for that session instead.
    const apiMatch = recordingLink.match(/api\.thelessonspace\.com\/.*\/sessions\/([0-9a-f-]{36})\/playback/i);
    return withTs(apiMatch ? `${PLAYBACK_BASE}/${apiMatch[1]}` : recordingLink);
  }

  const uuid = lessonspaceSessionId || sessionExternalId;
  if (!uuid) return null;
  // NOTE: seeded demo sessions carry synthetic ids ("demo-<uuid>") that
  // Lessonspace renders as "Unexpected Error". The link is shown anyway so the
  // feature is visible on demo data; real sessions resolve normally.
  return withTs(`${PLAYBACK_BASE}/${uuid}`);
};

export default buildLessonspaceRecordingUrl;
